var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5064 7.74634C8.4864 7.74634 8.47307 7.74634 8.45307 7.74634C8.41973 7.73967 8.37307 7.73967 8.33307 7.74634C6.39973 7.68634 4.93973 6.16634 4.93973 4.29301C4.93973 2.38634 6.49307 0.833008 8.39973 0.833008C10.3064 0.833008 11.8597 2.38634 11.8597 4.29301C11.8531 6.16634 10.3864 7.68634 8.5264 7.74634C8.51973 7.74634 8.51307 7.74634 8.5064 7.74634ZM8.39973 1.83301C7.0464 1.83301 5.93973 2.93967 5.93973 4.29301C5.93973 5.62634 6.97973 6.69967 8.3064 6.74634C8.33973 6.73967 8.43307 6.73967 8.51973 6.74634C9.8264 6.68634 10.8531 5.61301 10.8597 4.29301C10.8597 2.93967 9.75307 1.83301 8.39973 1.83301Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51307 15.033C7.2064 15.033 5.89307 14.6997 4.89973 14.033C3.97307 13.4197 3.4664 12.5797 3.4664 11.6663C3.4664 10.753 3.97307 9.90634 4.89973 9.28634C6.89973 7.95967 10.1397 7.95967 12.1264 9.28634C13.0464 9.89968 13.5597 10.7397 13.5597 11.653C13.5597 12.5663 13.0531 13.413 12.1264 14.033C11.1264 14.6997 9.81973 15.033 8.51307 15.033ZM5.45307 10.1263C4.81307 10.553 4.4664 11.0997 4.4664 11.673C4.4664 12.2397 4.81973 12.7863 5.45307 13.2063C7.11307 14.3197 9.91307 14.3197 11.5731 13.2063C12.2131 12.7797 12.5597 12.233 12.5597 11.6597C12.5597 11.093 12.2064 10.5463 11.5731 10.1263C9.91307 9.01967 7.11307 9.01967 5.45307 10.1263Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBlue);
export default __webpack_public_path__ + "static/media/profile-blue.d04fab968f1fbe09c39276683b4e6948.svg";
export { ForwardRef as ReactComponent };